// eslint-disable-next-line import/prefer-default-export
export class PaginationUtils {
  // OCULTA EL PAGINADO SI SE VISUALIZA DESDE SMARTPHONE VIA BROWSER O APP
  static showOrHidePagination = (isApp: boolean) => {
    if (window.outerWidth < 992 || isApp) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const pagination = document.querySelector('.react-bs-table-pagination');
      if (pagination !== null) pagination.classList.add('hidden');
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      const pagination = document.querySelector('.react-bs-table-pagination');
      if (pagination !== null) pagination.classList.remove('hidden');
    }
  };

  //  PAGINADO AUTOMATICO PARA VERSION MOVIL (BROWSER Y APP)
  static smartphonePagination = (
    isApp: boolean,
    rowsToShow: number,
    setRowsToShow: (num: number) => void,
    data: any[],
  ) => {
    if (window.outerWidth < 992 || isApp) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-shadow
      const observer = new IntersectionObserver((entries, observer) => {
        const rowList = document.querySelectorAll('.tr-static');
        const lastTr = rowList[data.length - 1];
        // verificamos si actualmente es visible la ultima fila de la tabla
        if (
          entries[0].isIntersecting &&
          rowsToShow < data.length &&
          lastTr === undefined
        ) {
          // incrementamos la cantidad de fila a mostrarse
          setRowsToShow(rowsToShow + 10);
          const target = document.querySelectorAll('.tr-static');
          const lastRow = target[target.length - 1];
          observer.unobserve(lastRow);
        }
      }, {});
      const target = document.querySelectorAll('.tr-static');
      const lastRow = target[target.length - 1];
      if (lastRow) {
        observer.observe(lastRow);
      }
    }
  };

  // MUESTRA LA PRIMERA CASILLA DE LOS PUNTOS SUSPENSIVOS DE SER NECESARIO
  static firstSuspPoints = () => {
    const newItem = document.createElement('li');
    newItem.classList.add('page-item', 'first-ellipsis');
    const linkNode = document.createElement('a');
    linkNode.classList.add('page-link');
    const textNode = document.createTextNode('...');
    linkNode.appendChild(textNode);
    newItem.appendChild(linkNode);
    return newItem;
  };

  // MUESTRA LA ULTIMA CASILLA DE LOS PUNTOS SUSPENSIVOS DE SER NECESARIO
  static lastSuspPoints = () => {
    const newItem = document.createElement('li');
    newItem.classList.add('page-item', 'last-ellipsis');
    const linkNode = document.createElement('a');
    linkNode.classList.add('page-link');
    const textNode = document.createTextNode('...');
    linkNode.appendChild(textNode);
    newItem.appendChild(linkNode);
    return newItem;
  };

  // ESCUCHA CUANDO SE QUIERE IR A LA PRIMERA POSICION
  static listenerGoToFirst = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const firstElement = document.querySelector('[title="1"]') as HTMLElement;
    if (firstElement !== null)
      firstElement.getElementsByTagName('a')[0].click();
  };

  // SITUA EL PAGINADO EN LA PRIMERA POSICION
  static goToFirstPage = () => {
    const goToFirstElement = document.getElementById('first-page');
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const newElement = document.importNode(goToFirstElement, true);
    newElement.setAttribute('title', 'first page2');
    newElement.addEventListener(
      'click',
      PaginationUtils.listenerGoToFirst,
      false,
    );
    newElement.classList.remove('hidden');
    return newElement;
  };

  // ESCUCHA CUANDO SE QUIERE IR A LA ULTIMA POSICION
  static listenerGoToLast = (e, cantPag) => {
    e.preventDefault();
    e.stopPropagation();
    const lastElement = document.querySelector(
      `[title="${cantPag}"]`,
    ) as HTMLElement;
    if (lastElement !== null) lastElement.getElementsByTagName('a')[0].click();
  };

  // SITUA EL PAGINADO EN LA ULTIMA POSICION
  static goToLastPage = (cantPag: number) => {
    const goToLastElement = document.getElementById('last-page');
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const newElement = document.importNode(goToLastElement, true);
    newElement.setAttribute('title', 'last page2');
    newElement.addEventListener(
      'click',
      (e) => PaginationUtils.listenerGoToLast(e, cantPag),
      false,
    );
    return newElement;
  };

  // SE AÑADE EL PAGINADO CON LOS BOTONES DE MOVIMIENTO FIJOS
  // Algunos de los botones de movimiento se crearon manualmente ya que el componente base ocultaba los propios cuando no aplicaban
  static addPagination = (
    cantPag: number,
    load: number,
    setLoad: (load: number) => void,
    setHasLastPoints: (has: boolean) => void,
  ) => {
    const firstElement = document.querySelector('[title="first page"]');
    const firstElement2 = document.querySelector('[title="first page2"]');

    if (firstElement === null && firstElement2 === null) {
      const prevElement = document.querySelector('[title="previous page"]');
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      prevElement.before(PaginationUtils.goToFirstPage());
    }

    if (cantPag <= 5) {
      const lastElement = document.querySelector('[title="last page"]');
      const lastElement2 = document.querySelector('[title="last page2"]');
      if (lastElement === null) {
        const nextElement = document.querySelector('[title="next page"]');
        if (lastElement2 === null) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          nextElement.after(PaginationUtils.goToLastPage(cantPag));
          const buttonLastElement = document.querySelector(
            '[title="last page2"]',
          );
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          buttonLastElement.classList.remove('hidden');
          if (cantPag === 1) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            buttonLastElement.classList.add('disabled');
          }
        } else if (cantPag === 1) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          lastElement2.classList.add('disabled');
        }
      }
    }

    if (cantPag > 5) {
      const nextElement = document.querySelector('[title="next page"]');
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      nextElement.before(PaginationUtils.lastSuspPoints());
      setHasLastPoints(true);
    }

    const buttonFirstElement = document.querySelector('[title="first page2"]');
    if (buttonFirstElement !== null)
      buttonFirstElement.classList.add('disabled');
    setLoad(1);
  };

  // MECANISMO PARA EL FUNCIONAMIENTO DEL PAGINADO
  static configPagination = (
    page: number,
    cantPag: number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasFirstPoints: boolean,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setHasFirstPoints: (has: boolean) => void,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasLastPoints: boolean,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setHasLastPoints: (has: boolean) => void,
  ) => {
    setTimeout(() => {
      // if (page >= 4 && cantPag > 5) {
      //   const buttonFirstElement = document.querySelector(
      //     '[title="first page2"]',
      //   );
      //   if (buttonFirstElement !== null)
      //     buttonFirstElement.classList.add('hidden');
      //
      //   const buttonLastElement = document.querySelector(
      //     '[title="last page2"]',
      //   );
      //   if (buttonLastElement !== null) {
      //     buttonLastElement.classList.add('hidden');
      //     // buttonLastElement.classList.remove('disabled');
      //   }
      // } else if (page < 4 && cantPag > 5) {
      //   const buttonFirstElement = document.querySelector(
      //     '[title="first page2"]',
      //   );
      //   if (buttonFirstElement !== null)
      //     buttonFirstElement.classList.remove('hidden');
      // }
      //
      // if (cantPag - page >= 3 && cantPag > 5) {
      //   const buttonLastElement = document.querySelector(
      //     '[title="last page2"]',
      //   );
      //   if (buttonLastElement !== null) {
      //     buttonLastElement.remove();
      //   }
      // } else if (cantPag - page < 3) {
      //   const nextElement = document.querySelector('[title="next page"]');
      //   const buttonLastElementExist = document.querySelector(
      //     '[title="last page2"]',
      //   );
      //   if (buttonLastElementExist === null) {
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //     // @ts-ignore
      //     nextElement.after(PaginationUtils.goToLastPage(cantPag));
      //     const buttonLastElement = document.querySelector(
      //       '[title="last page2"]',
      //     );
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //     // @ts-ignore
      //     buttonLastElement.classList.remove('hidden');
      //   } else {
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //     // @ts-ignore
      //     buttonLastElementExist.classList.remove('hidden');
      //   }
      // }
      //
      // if (page === cantPag) {
      //   const buttonFirstElement = document.querySelector(
      //     '[title="first page2"]',
      //   );
      //   const buttonLastElement = document.querySelector(
      //     '[title="last page2"]',
      //   );
      //   if (buttonLastElement !== null)
      //     buttonLastElement.classList.add('disabled');
      //   if (buttonFirstElement !== null && cantPag > 5)
      //     buttonFirstElement.classList.add('hidden');
      // } else {
      //   const buttonLastElement = document.querySelector(
      //     '[title="last page2"]',
      //   );
      //   if (buttonLastElement !== null) {
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //     // @ts-ignore
      //     buttonLastElement.classList.remove('disabled');
      //   }
      // }
      //
      // if (page === 1) {
      //   const buttonFirstElement = document.querySelector(
      //     '[title="first page2"]',
      //   );
      //   if (buttonFirstElement !== null)
      //     buttonFirstElement.classList.add('disabled');
      // } else {
      //   const buttonFirstElement = document.querySelector(
      //     '[title="first page2"]',
      //   );
      //   if (buttonFirstElement !== null) {
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //     // @ts-ignore
      //     buttonFirstElement.classList.remove('disabled');
      //   }
      // }

      if (page >= 4 && !hasFirstPoints && cantPag > 5) {
        const buttonFirstElement = document.querySelector(
          '[title="first page2"]',
        );
        if (buttonFirstElement !== null)
          buttonFirstElement.classList.add('hidden');

        const buttonLastElement = document.querySelector(
          '[title="last page2"]',
        );
        if (buttonLastElement !== null) {
          buttonLastElement.classList.add('hidden');
          // buttonLastElement.classList.remove('disabled');
        }

        const prevElement = document.querySelector('[title="previous page"]');
        if (cantPag > 5) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          prevElement.after(PaginationUtils.firstSuspPoints());
          setHasFirstPoints(true);
        }
      } else if (page < 4 && hasFirstPoints && cantPag > 5) {
        const buttonFirstElement = document.querySelector(
          '[title="first page2"]',
        );
        if (buttonFirstElement !== null)
          buttonFirstElement.classList.remove('hidden');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const element = document.querySelector('li.first-ellipsis');
        if (element !== null) element.remove();
        setHasFirstPoints(false);
      }

      if (cantPag - page >= 3 && cantPag > 5) {
        if (hasLastPoints) {
          const element = document.querySelector('li.last-ellipsis');
          if (element !== null) element.remove();
        }
        const nextElement = document.querySelector('[title="next page"]');
        if (cantPag > 5) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          nextElement.before(PaginationUtils.lastSuspPoints());
          setHasLastPoints(true);
        }
        const buttonLastElement = document.querySelector(
          '[title="last page2"]',
        );
        if (buttonLastElement !== null) {
          buttonLastElement.remove();
        }
      } else if (cantPag - page < 3 && hasLastPoints) {
        const nextElement = document.querySelector('[title="next page"]');
        const buttonLastElementExist = document.querySelector(
          '[title="last page2"]',
        );
        if (buttonLastElementExist === null) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          nextElement.after(PaginationUtils.goToLastPage(cantPag));
          const buttonLastElement = document.querySelector(
            '[title="last page2"]',
          );
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          buttonLastElement.classList.remove('hidden');
        }

        const element = document.querySelector('li.last-ellipsis');
        if (element !== null) element.remove();
        setHasLastPoints(false);
      }

      if (page === cantPag) {
        const buttonFirstElement = document.querySelector(
          '[title="first page2"]',
        );
        const buttonLastElement = document.querySelector(
          '[title="last page2"]',
        );
        if (buttonLastElement !== null)
          buttonLastElement.classList.add('disabled');
        if (buttonFirstElement !== null && cantPag > 5)
          buttonFirstElement.classList.add('hidden');
      } else {
        const buttonLastElement = document.querySelector(
          '[title="last page2"]',
        );
        if (buttonLastElement !== null) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          buttonLastElement.classList.remove('disabled');
        }
      }

      if (page === 1) {
        const buttonFirstElement = document.querySelector(
          '[title="first page2"]',
        );
        if (buttonFirstElement !== null)
          buttonFirstElement.classList.add('disabled');
      } else {
        const buttonFirstElement = document.querySelector(
          '[title="first page2"]',
        );
        if (buttonFirstElement !== null) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          buttonFirstElement.classList.remove('disabled');
        }
      }
    }, 1);
  };

  static reloadPagination = (cantPag: number) => {
    const firstPage = document.querySelector(
      '[title="first page"]',
    ) as HTMLElement;
    const firstPage2 = document.querySelector(
      '[title="first page2"]',
    ) as HTMLElement;
    setTimeout(() => {
      if (firstPage !== null) {
        firstPage.getElementsByTagName('a')[0].click();
      }
      if (firstPage2 !== null) {
        firstPage2.classList.remove('hidden');
        firstPage2.getElementsByTagName('a')[0].click();
      }
    }, 2);

    // Opcional en un futuro
    const firstEllipsis = document.querySelector('.first-ellipsis');
    if (firstEllipsis !== null) firstEllipsis.remove();
    const lastEllipsis = document.querySelector('.last-ellipsis');
    if (lastEllipsis !== null) lastEllipsis.remove();

    const lastPage2 = document.querySelector('[title="last page2"]');
    if (lastPage2 !== null && cantPag > 5) {
      lastPage2.remove();
    } else if (lastPage2 !== null) {
      lastPage2.remove();
    }
  };
}
